function n(r, t, e) {
  return !r || r[t] === void 0 ? e : r[t];
}
export {
  n as getProp
};
